<template>
  <el-dialog title="订单详情" :width="'98%'" :custom-class="'custom-dialog'" center top="2%" :visible.sync="dialogFormVisible" :close-on-click-modal="true" @close="$emit('input',false)">
      <el-tabs v-model="activeTableKey" @tab-click="handleClick">
        <el-tab-pane v-for="table in tables" :label="table.label" :name="table.key">
          <CustomTool :show-filter="false" :show-refresh="true" :show-time-area="false" :show-time="false" :show-time-text="false" :show-export="true" @filters="refresh" @export="exportExcelPerformanceDetail"/>
          <div style="height: 100%;padding:20px 0px;overflow: scroll;background:white;">
            <!--
            //列表相关
            @row-click 点击列表某个item事件
            project-list-dl 表格列表内容

            //列和表头相关
            @column-drop 表头拖动排序事件
            show-coloums-dl 显示的列（即表头显示的）
            column_mapper 所有的列枚举（包含未在表头显示的）

            //排序相关
            @sort-change 排序变化事件
            sort-column-name-dl 排序的名称
            sort-column-order-dl 排序的规则

            //页面控制相关
            @current-change  当前页改变事件
            totalnums-dl 总页数
            pagesize-dl 每页页数
            page-number-dl 当前页
      :default-sort="getToolConfigValueFromContentMap.sort"
                @sort-change="sortChange"
                :sort-column-name-dl="tableData.sortColumnName"
                :sort-column-order-dl="tableData.sortColumnOrder"
            //表头固定
            fixed-columns
            -->
            <custom-table
                ref="mytable"
                style="height:800px;"

                table-id="salesDataDetailTable"
                @row-click="rowClick"
                :project-list-dl="table.tableData.showProjectList"

                :show-coloums-dl="table.tableData.showColoums"
                :column_mapper="table.tableData.column_mapper"

                @sort-change="sortChange"
                :sort-column-name-dl="table.tableData.sortColumnName"
                :sort-column-order-dl="table.tableData.sortColumnOrder"

                @current-change="(e)=>currentChange(table.tableData,e)"
                :totalnums-dl="table.tableData.totalnums"
                :pagesize-dl="table.tableData.pagesize"
                :page-number-dl="table.tableData.pageNumber"

                :fixed-columns="table.tableData.fixedList"

                :disableDrag="true"

                :sortable="false"

                :pagination="table.tableData.pagination"

                :is-loading-dl="table.tableData.detailLoading"
                :use-virtual="false"
                :row-hegit="0"

                :tableColumnCustomConfig="table.tableData.tableColumnCustomConfig"
                @unusualShow="unusualShow"
            ></custom-table>
          </div>
        </el-tab-pane>
      </el-tabs>



  </el-dialog>
</template>

<script>
import CustomTable from "@/component/CustomTable";

import CustomCardTable from "@/component/Performance/dialog/CustomCardTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import {exportExcel, exportPerformanceDetail, getAdvance, getPerformance, getUnusualList} from "@/api/api";
export default {
  name: "SalesDataDetailDialog",
  components:{
    CustomCardTable,
    CustomTool,
    CustomTable
  },
  props:{
    column_mapper:{
      type:Object
    },
    filterRequestData:{
      type:Object
    },
    value:{
      type: Boolean,
      default:false,
      required: true
    }
  },
  data() {
    return {
      dialogFormVisible: false,

      refreshId:0,
      requestData:{},
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
      activeTableKey:"collection",
      tables:[
        {
          key:"collection",
          label:"回款",
          tableData:{
            //表格列表相关
            detailLoading: false,
            projectList: [],//表格列表所有数据
            showProjectList:[],//显示的数据
            column_mapper: {},//表头所有列的枚举
            showColoums: [],//当前显示的表头列
            sortColumnName: "",//需要排序的列名
            sortColumnOrder: "",//排序的命令
            totalnums: 10,//所有的数据条数
            pageNumber: 1,//当前页
            fixedList: ['project:project_id', 'project:project_name'],
            pagesize: 10,//一页数据的行数（公用）
            pagination:true,
            tableColumnCustomConfig:{//图表某些列定制化显示
              'project:project_id':{
                type:"popover",
                showRule:{
                  key:"project:project_remark",
                  value:"异常"
                },
                project_id:"",
                closeTime:1,
                openTime:0,
                forceClose:false,
                show:false,
                popoverDatas:[]
              }
            }
          }
        },
        {
          key:"invoice",
          label:"开票",
          tableData:{
            //表格列表相关
            detailLoading: false,
            projectList: [],//表格列表所有数据
            showProjectList:[],//显示的数据
            column_mapper: {},//表头所有列的枚举
            showColoums: [],//当前显示的表头列
            sortColumnName: "",//需要排序的列名
            sortColumnOrder: "",//排序的命令
            totalnums: 10,//所有的数据条数
            pageNumber: 1,//当前页
            fixedList: ['project:project_id', 'project:project_name'],
            pagesize: 10,//一页数据的行数（公用）
            pagination:true,
            tableColumnCustomConfig:{//图表某些列定制化显示
              'project:project_id':{
                type:"popover",
                showRule:{
                  key:"project:project_remark",
                  value:"异常"
                },
                project_id:"",
                closeTime:1,
                openTime:0,
                forceClose:false,
                show:false,
                popoverDatas:[]
              }
            }
          }
        },
        {
          key:"net_orders",
          label:"净订单",
          tableData:{
            //表格列表相关
            detailLoading: false,
            projectList: [],//表格列表所有数据
            showProjectList:[],//显示的数据
            column_mapper: {},//表头所有列的枚举
            showColoums: [],//当前显示的表头列
            sortColumnName: "",//需要排序的列名
            sortColumnOrder: "",//排序的命令
            totalnums: 10,//所有的数据条数
            pageNumber: 1,//当前页
            fixedList: ['project:project_id', 'project:project_name'],
            pagesize: 10,//一页数据的行数（公用）
            pagination:true,
            tableColumnCustomConfig:{//图表某些列定制化显示
              'project:project_id':{
                type:"popover",
                showRule:{
                  key:"project:project_remark",
                  value:"异常"
                },
                project_id:"",
                closeTime:1,
                openTime:0,
                forceClose:false,
                show:false,
                popoverDatas:[]
              }
            }
          }
        }
      ],

    };
  },

  watch:{
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        this.refresh()
      }
    },
    activeTableKey(newVal){
      this.refresh()
    }
  },

  mounted() {
    this.refresh()
  },

  computed:{
    currentTableData(){
      return this.tables.find(table=>table.key==this.activeTableKey).tableData
    },
    currentTable(){
      return this.tables.find(table=>table.key==this.activeTableKey)
    }
  },
  methods:{
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    async currentChange(tableData,e) {
      // console.log('currentChange',e)
      tableData.pageNumber = e;
      this.getCurrentPageData(tableData)
    },

    sortChange(e) {
      // console.log('sortChange',e)

      if (e.order === null) {
        this.filterContent.sortCond.columnName = ""
        this.filterContent.sortCond.value = ""
      } else {
        this.filterContent.sortCond.columnName  = e.prop
        if (e.order === 'ascending') {
          this.filterContent.sortCond.value = 'asc'
        } else {
          this.filterContent.sortCond.value = 'desc'
        }
      }
      this.refresh()
    },

    async unusualShow(project_id){
      let res = await getUnusualList({project_id: project_id})
      let resData = res.data

      if (resData.hasOwnProperty('respCode')) {
        if (resData.respCode == "000000") {
          this.currentTableData.tableColumnCustomConfig['project:project_id'].project_id = project_id
          this.currentTableData.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
        } else {
          this.$message.warning(resData.respMsg)
        }
      } else {
        this.$message.error("数据有误")
      }
    },

    rowClick(e){
      // console.log('rowClick', e['project_name'])
      this.$store.commit("setProjectId", e["project_id"]);
      this.$store.commit("setProjectInfo", {
        projectId: e["project_id"],
        projectName: e["project_name"],
        accu: 0
      })
      this.dialogFormVisible = false
    },

    async exportExcelPerformanceDetail(){
      let param = {
        ...this.requestData
      }
      // console.log('exportPerformanceDetail/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportPerformanceDetail(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        const fileName = this.currentTable.label + '订单详情' + '-' + Y + M + D + H + m + s + ".xlsx"
        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },


    getCurrentPageData(tableData){
      if(tableData.projectList.length > tableData.pagesize){
        tableData.showProjectList = tableData.projectList.slice((tableData.pageNumber-1)*tableData.pagesize,(tableData.pageNumber)*tableData.pagesize)
      }else{
        tableData.showProjectList = tableData.projectList
      }
    },

    async getData(resetPage=false){
      if(resetPage){
        this.currentTableData.pageNumber = 1
      }

      let postData = {
        division:"sale",
        index:this.currentTable.key,
        pagiInfo: {
          currentPage: this.currentTableData.pageNumber,
          pagesize: this.currentTableData.pagesize
        },
        timerange:{
          end:this.filterRequestData.time
        }
      }
      this.requestData = postData
      // console.log('postData', postData)
      let res = await getPerformance(postData)
      let resData = res.data
      const {respData: {cols_mapper, data , columns_list,totalnums}} = resData
      // console.log('返回结果', resData,cols_mapper,data,columns_list)
      this.currentTableData.column_mapper = cols_mapper
      this.currentTableData.projectList = data
      this.currentTableData.totalnums =  data.length
      this.currentTableData.showColoums = columns_list
      this.getCurrentPageData(this.currentTableData)

      // console.log('this.currentTableData.showColoums',this.currentTableData.showColoums )


      this.$nextTick(() => {
        this.currentTableData.detailLoading = false
      })



    },

    async refresh(resetPage=true){
      this.currentTableData.detailLoading = true
      await this.getData(resetPage)
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog.custom-dialog{
  /*height:96vh;*/
}
</style>
